<div class="p-2">
    <div class="d-flex justify-content-between align-items-center p-2">
        <h3 class="m-0">Vizualizare imagine</h3>
        <button type="button" class="btn_close w-auto" aria-label="Close" (click)="closeDialog()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="mt-2">
        <div class="row">
            <div class="image-container p-5">
                <img [src]="data.imageUrl" [style.transform]="rotateClass" class="fit-image rotate90" />
                <div class="d-flex justify-content-between align-items-center">
                    <button (click)="rotateImage()" class="btn_rotate">
                        <mat-icon>rotate_right</mat-icon>
                    </button>
                    <!-- <button (click)="downloadImage()" class="btn_download">
                        <mat-icon>cloud_download</mat-icon>
                    </button> -->
                </div>
            </div>
        </div>
    </div>
</div>
